/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignRequestSigner
 */
export interface SignRequestSigner {
    /**
     * The number of times that the recipient has been through a signing completion for this signing request. If greater than 0 for a signing group, only the user who previously completed may sign again
     * @type {string}
     * @memberof SignRequestSigner
     */
    completedCount?: string;
    /**
     * Specifies why this signer record was created
     * @type {string}
     * @memberof SignRequestSigner
     */
    creationReason?: string;
    /**
     * The date and time when the recipient declined to sign the document
     * @type {string}
     * @memberof SignRequestSigner
     */
    declinedDateTime?: string;
    /**
     * The reason provided by the recipient for declining the document
     * @type {string}
     * @memberof SignRequestSigner
     */
    declinedReason?: string;
    /**
     * The date and time when the envelope was delivered to the recipient
     * @type {string}
     * @memberof SignRequestSigner
     */
    deliveredDateTime?: string;
    /**
     * The method used to deliver the envelope to the recipient (reserved for DocuSign)
     * @type {string}
     * @memberof SignRequestSigner
     */
    deliveryMethod?: string;
    /**
     * The email address of the signer
     * @type {string}
     * @memberof SignRequestSigner
     */
    email?: string;
    /**
     * The full name of the signer
     * @type {string}
     * @memberof SignRequestSigner
     */
    name?: string;
    /**
     * A local reference that senders use to map recipients to other objects, such as specific document tabs. Within a sign request, each `recipientId` must be unique, but there is no uniqueness requirement across envelopes
     * @type {number}
     * @memberof SignRequestSigner
     */
    recipientId?: number;
    /**
     * The globally unique identifier (GUID) assigned to this recipient on a specific signing request. If the same recipient is associated with multiple signing requests, they will have a different GUID for each one
     * @type {string}
     * @memberof SignRequestSigner
     */
    recipientIdGuid?: string;
    /**
     * Specifies the recipient type, such as “signer” or “carbon copy”
     * @type {string}
     * @memberof SignRequestSigner
     */
    recipientType?: string;
    /**
     * Specify the role name assigned to the recipient within the signing workflow
     * @type {string}
     * @memberof SignRequestSigner
     */
    roleName?: string;
    /**
     * Defines the order in which the signer receives and signs the signing request
     * @type {number}
     * @memberof SignRequestSigner
     */
    routingOrder?: number;
    /**
     * The UTC timestamp indicating when the document was sent to the signer
     * @type {string}
     * @memberof SignRequestSigner
     */
    sentDateTime?: string;
    /**
     * The UTC timestamp indicating when the signer completed the signing process (reserved for DocuSign)
     * @type {string}
     * @memberof SignRequestSigner
     */
    signedDateTime?: string;
    /**
     * The unique identifier of the user associated with this signer. Typically this is the authenticated user, but administrators may specify another user they are managing
     * @type {string}
     * @memberof SignRequestSigner
     */
    userId?: string;
    /**
     * The current signing status of the recipient (for example, “sent,” “delivered,” “signed,” or “declined”)
     * @type {string}
     * @memberof SignRequestSigner
     */
    status?: string;
}

/**
 * Check if a given object implements the SignRequestSigner interface.
 */
export function instanceOfSignRequestSigner(value: object): boolean {
    return true;
}

export function SignRequestSignerFromJSON(json: any): SignRequestSigner {
    return SignRequestSignerFromJSONTyped(json, false);
}

export function SignRequestSignerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignRequestSigner {
    if (json == null) {
        return json;
    }
    return {
        
        'completedCount': json['completedCount'] == null ? undefined : json['completedCount'],
        'creationReason': json['creationReason'] == null ? undefined : json['creationReason'],
        'declinedDateTime': json['declinedDateTime'] == null ? undefined : json['declinedDateTime'],
        'declinedReason': json['declinedReason'] == null ? undefined : json['declinedReason'],
        'deliveredDateTime': json['deliveredDateTime'] == null ? undefined : json['deliveredDateTime'],
        'deliveryMethod': json['deliveryMethod'] == null ? undefined : json['deliveryMethod'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'recipientId': json['recipientId'] == null ? undefined : json['recipientId'],
        'recipientIdGuid': json['recipientIdGuid'] == null ? undefined : json['recipientIdGuid'],
        'recipientType': json['recipientType'] == null ? undefined : json['recipientType'],
        'roleName': json['roleName'] == null ? undefined : json['roleName'],
        'routingOrder': json['routingOrder'] == null ? undefined : json['routingOrder'],
        'sentDateTime': json['sentDateTime'] == null ? undefined : json['sentDateTime'],
        'signedDateTime': json['signedDateTime'] == null ? undefined : json['signedDateTime'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function SignRequestSignerToJSON(value?: SignRequestSigner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'completedCount': value['completedCount'],
        'creationReason': value['creationReason'],
        'declinedDateTime': value['declinedDateTime'],
        'declinedReason': value['declinedReason'],
        'deliveredDateTime': value['deliveredDateTime'],
        'deliveryMethod': value['deliveryMethod'],
        'email': value['email'],
        'name': value['name'],
        'recipientId': value['recipientId'],
        'recipientIdGuid': value['recipientIdGuid'],
        'recipientType': value['recipientType'],
        'roleName': value['roleName'],
        'routingOrder': value['routingOrder'],
        'sentDateTime': value['sentDateTime'],
        'signedDateTime': value['signedDateTime'],
        'userId': value['userId'],
        'status': value['status'],
    };
}

